import ResultFramework from '../../features/LogframeDefinition';

type ProjectLogDefinitionPropsType = {
    projectID: number;
};
const LogFrameDefinition = ({ projectID }: ProjectLogDefinitionPropsType) => <ResultFramework id={projectID} />;

export default LogFrameDefinition;
